__turbopack_context__.v({
  "marquee": "nav-menu-logo-marquee-module__piyHIq__marquee",
  "track": "nav-menu-logo-marquee-module__piyHIq__track",
});
